export default __webpack_public_path__ + "static/media/not-found.74b0cae7.png";